module.exports = __webpack_public_path__ + "img/tv_yes.d629277f.png";